import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';



import React, { useState, useEffect } from 'react';

import AddressBlock from '../blocks/AddressBlock';
import DateBlock from '../blocks/DateBlock';
import { GetHeaders, PostDataFetch } from '../../hooks/DataFetch';
import GenericFormContainer from './FormContainer';
import { INTRFUser, AppUser } from '../../hooks/Interfaces';


import { useRef } from 'react';
import { IMaskInput } from 'react-imask';

interface CreateAccountProps {
    updatecsrf: (value: string) => void;
    updatesession: (value: string) => void;
}

function FormCreateAccount({updatecsrf, updatesession}: CreateAccountProps){
    let [user, setUser] = useState(AppUser());
    let [address, setAddress] = useState(user.address);

    let [username, setUsername] = useState("");
    let [pw, setPW] = useState("");
    let [pw2, setPW2] = useState("");
    let [email, setEmail] = useState("");

    let [address1, setAddress1] = useState(address.address1);
    let [address2, setAddress2] = useState(address.address2);
    let [city, setCity] = useState(address.city);
    let [state, setState] = useState(address.state);
    let [postalcode, setPostalCode] = useState(address.zip);

    

    let [firstname, setFirstname] = useState("");
    let [middlename, setMiddlename] = useState("");
    let [lastname, setLastname] = useState("");
    let [phone, setPhone] = useState("");

    let [dob_year, setYear] = useState(0);
    let [dob_month, setMonth] = useState(0);
    let [dob_day, setDay] = useState(0);

    let [page, setPage] = useState(1);
    
    
    // use ref to get access to internal "masked = ref.current.maskRef"
    const ref = useRef(null);
    const inputRef = useRef(null);
    const phonemask = [{ mask: '(000) 000-0000' }, { mask: '(000) 000-0000' }]
    const charmask = [{mask: '/^[a-zA-Z]*$/'}]

    const nextPage = () => {
        console.log("next page")
        if(page == 1 && !validatePage1()){
            setPage(1)
            return 
        }

        if(page < 3){
            setPage(page + 1)
        }

    }

    const prevPage = () => {
        console.log("previous page")
        if(page > 1){
            setPage(page - 1)
        }

    }

    const validatePage1 = (): boolean => {
        if(!validalphasequence(firstname)) { return false }
        if(!validalphasequence(lastname)) { return false }
        if(!validemail()) { return false }
        setUsername(email)//TODO find a better way
        if(!validphone()) { return false }
        return true
    }

    const validatePage2 = (): boolean => {
        if(!validalphanumsequence(address1)) { return false }
        //if(!validalphanumsequence(address2)) { return false }
        if(!validalphanumsequence(city)) { return false }
        if(!validalphanumsequence(state)) { return false }
        if(!validalphanumsequence(postalcode)) { return false }
        return true
    }

    const validatePage3 = (): boolean => {
        if(!validpassword()) {return false;}
        return true
    }

    const validalphanumsequence = (text: string): boolean => {
        const textregex = /^[a-zA-Z0-9 ]{2,}$/i;
        return textregex.test(text)
    }

    const validalphasequence = (text: string):boolean => {
        const textregex = /^[a-zA-Z]{2,}$/i;
        textregex.test(text)
        return textregex.test(text)
    }

    const validemail = ():boolean => {
        const emailregex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        emailregex.test(email)
        return emailregex.test(email)
    }

    const validphone = ():boolean => {
        const phoneregex = /^[0-9]{10}$/i;
        return phoneregex.test(phone)
    }

    const validpassword = ():boolean => {
        if(pw == "") { return false; }
        if(pw.length < 8) { return false; }
        if(pw != pw2) { return false; }

        return true
    }

    const handleSubmit = async (event: React.SubmitEvent) => {
        event.preventDefault();
        

        let axiosConfig = GetHeaders();
        const posturl = process.env.REACT_APP_API_URL + "/v1/user/create";
        const formdata = {
            username, pw, email,
            address1, address2, city, state, postalcode,
            firstname, lastname,
            dob_year, dob_month, dob_day
        };
        let response = await PostDataFetch({url: posturl, headers: axiosConfig, data: formdata})
        //Update app data after successful return

        //Handle a Non 200 response
        if(response.status == 200){
            updatesession(response.session_state.session_id);
        }else{
            //Error handling
            console.log(response)
        }
        
    };

    const updateAddress = (a: any) => {
        setAddress1(a.address1)
        setAddress2(a.address2)
        setCity(a.city)
        setState(a.state)
        setPostalCode(a.zip)
  
    }
    /* Component Init */
    useEffect(() => {
        console.log(phone)
        if(page > 1 && !validatePage1()){
            setPage(1)
        }
        
    }, [page]);

    return (
        <> 
            <GenericFormContainer>
                <Row className="">
                    <Col>
                        <p className="text-start text-font-body text-font-size-large">Create Account</p>
                        Page {page} of 3
                    </Col>
                </Row>
                <Row>
                    
                    <form onSubmit={handleSubmit}>
                        
                        <Col md={{span:12}}  className="mb-4">
                            { (page == 1) &&
                                <>
                                    <Row className="py-1">
                                        <Col className="">
                                            <div className={ true ? "brand-tertiary-color-border" : "brand-alert-input"}>
                                                <IMaskInput
                                                    id="first_name"
                                                    mask={/^[a-zA-Z]*$/}
                                                    minLength={2}
                                                    maxLength={7}
                                                    className="border-0 input-fill no-generic-input-styles"
                                                    type="text"
                                                    radix="."
                                                    value={firstname}
                                                    aria-describedby='firstNameHelp'
                                                    unmask={true} // true|false|'typed'
                                                    ref={ref}
                                                    inputRef={inputRef}  // access to nested input
                                                    // DO NOT USE onChange TO HANDLE CHANGES!
                                                    // USE onAccept INSTEAD
                                                    onAccept={
                                                        // depending on prop above first argument is
                                                        // `value` if `unmask=false`,
                                                        // `unmaskedValue` if `unmask=true`,
                                                        // `typedValue` if `unmask='typed'`
                                                        //(value, mask) => console.log(value)
                                                        (value, mask) => setFirstname(value)
                                                    }
                                                    // ...and more mask props in a guide

                                                    // input props also available
                                                    placeholder='First name *'
                                                />
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className="brand-tertiary-color-border">
                                                <input placeholder="Middle name" type="text" className="border-0 input-fill no-generic-input-styles" id="middle_name" aria-describedby="middleNameHelp" onChange={(e) => setMiddlename(e.target.value)}/>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className="brand-tertiary-color-border">
                                                <IMaskInput
                                                    id="last_name"
                                                    mask={/^[a-zA-Z]*$/}
                                                    minLength={2}
                                                    maxLength={7}
                                                    className="border-0 input-fill no-generic-input-styles"
                                                    type="text"
                                                    radix="."
                                                    value={lastname}
                                                    aria-describedby='lastNameHelp'
                                                    unmask={true} // true|false|'typed'
                                                    ref={ref}
                                                    inputRef={inputRef}  // access to nested input
                                                    // DO NOT USE onChange TO HANDLE CHANGES!
                                                    // USE onAccept INSTEAD
                                                    onAccept={
                                                        // depending on prop above first argument is
                                                        // `value` if `unmask=false`,
                                                        // `unmaskedValue` if `unmask=true`,
                                                        // `typedValue` if `unmask='typed'`
                                                        //(value, mask) => console.log(value)
                                                        (value, mask) => setLastname(value)
                                                    }
                                                    // ...and more mask props in a guide

                                                    // input props also available
                                                    placeholder='Last name *'
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className="py-1">
                                        <Col>
                                            <div className={ validemail() ? "brand-tertiary-color-border" : "brand-alert-input"}>
                                                <IMaskInput
                                                    id="email"
                                                    mask={/^[\S+]+$/}
                                                    minLength={5}
                                                    maxLength={40}
                                                    className="border-0 input-fill no-generic-input-styles"
                                                    type="email"
                                                    radix="."
                                                    value={email}
                                                    aria-describedby='emailHelp'
                                                    unmask={true} // true|false|'typed'
                                                    ref={ref}
                                                    inputRef={inputRef}  // access to nested input
                                                    // DO NOT USE onChange TO HANDLE CHANGES!
                                                    // USE onAccept INSTEAD
                                                    onAccept={
                                                        // depending on prop above first argument is
                                                        // `value` if `unmask=false`,
                                                        // `unmaskedValue` if `unmask=true`,
                                                        // `typedValue` if `unmask='typed'`
                                                        //(value, mask) => console.log(value)
                                                        (value, mask) => setEmail(value)
                                                    }
                                                    // ...and more mask props in a guide

                                                    // input props also available
                                                    placeholder='E-Mail *'
                                                />
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className="brand-tertiary-color-border">
                                                <IMaskInput
                                                    id="phone"
                                                    mask={phonemask}
                                                    className="border-0 input-fill no-generic-input-styles"
                                                    type="tel"
                                                    radix="."
                                                    value={phone}
                                                    aria-describedby='telhelp'
                                                    unmask={true} // true|false|'typed'
                                                    ref={ref}
                                                    inputRef={inputRef}  // access to nested input
                                                    // DO NOT USE onChange TO HANDLE CHANGES!
                                                    // USE onAccept INSTEAD
                                                    onAccept={
                                                        // depending on prop above first argument is
                                                        // `value` if `unmask=false`,
                                                        // `unmaskedValue` if `unmask=true`,
                                                        // `typedValue` if `unmask='typed'`
                                                        //(value, mask) => console.log(value)
                                                        (value, mask) => setPhone(value)
                                                    }
                                                    // ...and more mask props in a guide

                                                    // input props also available
                                                    placeholder='Mobile Number (Texts) *'
                                                />
                                            </div>
                                            
                                        </Col>
                                    </Row>
                                    <Row className="py-1">
                                        <p className="text-start text-font-body text-font-size-medium">Date of Birth</p>
                                        <Col>
                                            <DateBlock formPrefix='dob' outputYear={setYear} outputMonth={setMonth} outputDay={setDay} />
                                        </Col>
                                    </Row>
                                    <Row>

                                        <Col xs={{span: 6, offset: 6}}>
                                            <button type="button" className="btn brand-btn-secondary-color w-100" onClick={nextPage}>Next</button>
                                        </Col>
                                    </Row>
                                </>
                            }
                            

                            { (page == 2) &&
                                <>
                                    <Row className="py-1 mb-2">
                                        <Col>
                                            <p className="text-start text-font-body text-font-size-medium">Delivery Address</p>({address1})
                                            <AddressBlock formPrefix='delivery'  address={{ address1: address1, address2: address2, city: city, state: state, zip: postalcode}} updateAddress={updateAddress} />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <button type="button" className="btn brand-btn-secondary-color w-100" onClick={prevPage}>Previous</button>
                                        </Col>
                                        <Col>
                                            <button type="button" className="btn brand-btn-secondary-color w-100" onClick={nextPage} disabled={!validatePage2()}>Next</button>
                                        </Col>
                                    </Row>
                                </>
                            }

                            { (page == 3) &&
                                <>
                                    <Row className="py-1 mb-2">
                                        <Col>
                                            <div className="brand-tertiary-color-border">
                                                <input placeholder="Username" type="text" className="border-0 input-fill no-generic-input-styles" id="username" aria-describedby="usernameHelp" onChange={(e) => setUsername(e.target.value)} value={username} />
                                            </div>
                                            
                                        </Col>
                                    </Row>
                                    <Row className="py-1 mb-3">
                                        <Col>
                                            <div className="brand-tertiary-color-border">
                                                <input placeholder="Password" type="password" className="border-0 input-fill no-generic-input-styles" id="password" aria-describedby="passwordHelp" onChange={(e) => setPW(e.target.value)}/>
                                            </div>
                                            
                                        </Col>
                                        <Col>
                                            <div className="brand-tertiary-color-border">
                                                <input placeholder="Confirm Password" type="password" className="border-0 input-fill no-generic-input-styles" id="password2" aria-describedby="passwordHelp" onChange={(e) => setPW2(e.target.value)}/>
                                            </div>
                                            
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <button type="button" className="btn brand-btn-secondary-color w-100" onClick={prevPage}>Previous</button>
                                        </Col>
                                        <Col>
                                            <button type="submit" className="btn brand-btn-secondary-color w-100" disabled={!validatePage3()}>Create Account</button>
                                        </Col>
                                    </Row>
                                    
                                </>
                            }
                            

                            
                            
                        </Col>
                        
                        
                        
                    </form>
                    
                </Row>

            </GenericFormContainer>
        </>
    )
}
export default FormCreateAccount;